<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" lg="4" md="6" sm="8">
        <ValidationObserver
          ref="passwordForm"
          v-slot="{
            // eslint-disable-next-line vue/no-unused-vars
            invalid,
            // eslint-disable-next-line vue/no-unused-vars
            passes,
          }"
        >
          <v-row>
            <v-col class="justify-center mb-6">
              <v-img contain src="@/assets/logo_horizontal.svg" height="55"></v-img>
            </v-col>
          </v-row>
          <v-form rel="passwordForm" @submit.prevent="passes(submitReset)">
            <v-card class="elevation-12">
              <v-card-title flat class="justify-center ma-6">
                <v-toolbar-title>Obnova hesla</v-toolbar-title>
              </v-card-title>
              <v-card-text class="mb-0">
                <VTextFieldWithValidation
                  v-model="form.password"
                  vid="password"
                  rules="required|password"
                  outlined
                  dense
                  icon="mdi-lock"
                  type="password"
                  label="Heslo"
                  data-cy="password"
                />
                <VTextFieldWithValidation
                  v-model="form.passwordRetype"
                  rules="required|confirmed-password:password"
                  outlined
                  dense
                  icon="mdi-lock"
                  type="password"
                  label="Heslo znovu"
                  data-cy="passwordRetype"
                />
              </v-card-text>
              <v-card-actions class="pl-4 pr-4 pb-4">
                <v-btn
                  type="submit"
                  block
                  color="primary"
                  height="40px"
                  depressed
                  :loading="isLoggin"
                >
                  Odeslat
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-alert v-if="errorMessage" type="error" class="mt-4">
              {{ errorMessage }}
            </v-alert>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'PasswordReset',
  data() {
    return {
      form: {
        password: '',
        passwordRetype: '',
      },
      code: '',
      errorMessage: null,
      isLoggin: false,
    }
  },
  methods: {
    ...mapActions({
      passwordResetConfirm: 'user/passwordResetConfirm',
    }),
    submitReset() {
      if (!this.form.password.length) return
      if (!this.form.passwordRetype.length) return
      if (this.form.password !== this.form.passwordRetype) return

      this.errorMessage = null
      this.isLoggin = true
      this.passwordResetConfirm({ code: this.$route.query.code, password: this.form.password })
        .then(() => {
          this.$router.push({
            name: 'login',
          })
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.errorMessage = error.response.data.message
          }
          if (error.response && error.response.status === 400) {
            this.errorMessage = error.response.data.message
          }
        })
        .finally(() => {
          this.isLoggin = false
        })
    },
  },
}
</script>
